<template>
    <header>
        <!-- DESKTOP HEADER -->
        <div class="header-desktop">
            <div class="header-top">
                <div class="header-top-left">
                    <p class="parag parag-white">{{ currenttime | getLocalDate }}</p>
                    <div class="header-info">
                        <!--router-link to="/web/wiki/how-to-bet" class="parag">{{ $t('HOWTOBET') }}</router-link>
                        <router-link to="/web/wiki/payment-methods" class="parag">{{ $t('PAYMENTMETHODS') }}</router-link>
                        <router-link to="/web/wiki/need-help" class="parag">{{ $t('NEEDHELP') }}</router-link-->
                        <router-link to="/web/results/sport/prematch" v-if="verticalsAvailable.prematch" class="parag">{{ $t('RESULTS') }}</router-link>
                        <router-link :to="'/web/results/' + getFirstAvailableResultsPage() + '/'" v-else class="parag">{{ $t('RESULTS') }}</router-link>
                    </div>
                    <p v-if="showGitHash" class="parag header-info">{{ getGitHash }}</p>
                </div>

                <div v-if="true" class="header-top-right">
                    <p class="parag">
                        <a @click="changeRouteLang('hr-HR')">hr-HR</a>
                    </p>
                    <p class="parag">
                        <a @click="changeRouteLang('en-GB')">en-GB</a>
                    </p>
                    <p class="parag">{{ $t('POWEREDBYLEAPBIT') }}</p>
                    <!--p class="parag">{{ $t('FORGOTPASSWORD') }}</p>
                    <img class="mobile-phone-icon" src="../../assets/img/phone.svg" alt="">
                    <img class="chat-icon" src="../../assets/img/chat.svg" alt=""-->
                </div>

            </div>
            <div class="header-bottom">
                <div class="header-bottom-left">
                   <router-link :to="`/${globals.langCode}`" class="logo-box" >
                        <img v-if="getClientName === 'arenabet'"
                        src="../../assets/img/logo-arenabet.svg" alt="">
                        <img v-else
                        src="../../assets/img/logo-em.svg" alt="" class="logo-default">
                    </router-link>
                    <nav class="main-nav">
                        <template v-for="(val, page) in verticalsAvailable">
                            <div class="mnav-item" :key="page" v-if="val">
                                <router-link :to="getPageUrl(page)" class="mnav-link">{{ $t(page.toUpperCase() + '_BETTINGVERTICAL') }}</router-link>
                                <div class="link-line"></div>
                            </div>
                        </template>
                    </nav>
                </div>
                <div class="header-bottom-right" v-if="!playerloggedin">
                    <div class="loading-container" v-if="loginLoading"><img src="../../assets/img/loading.svg"></div>
                    <!-- router-link to="/web/registration" class="button button-yellow">{{ $t('REGISTER')}}</router-link -->
                    <div class="input-box">
                        <input v-on:keyup.enter="login" type="text" v-model="username" class="input-text header-username" ref_testcafe="loginUsername" placeholder="Username" :class="{'error': loginResponse.error}">
                        <p class="input-error" v-if="loginResponse.error">{{loginResponse.notice}}</p>
                    </div>
                    <div class="input-box">
                        <input v-on:keyup.enter="login" type="password" v-model="password" class="input-text header-password" ref_testcafe="loginPassword" placeholder="Password">
                    </div>
                    <a href="" v-on:click.prevent="login" ref_testcafe="loginButton" class="button button-grey-second">{{ $t('LOGIN')}}</a>
                </div>
                <div class="header-bottom-right" v-else>
                    <div class="loading-container" v-if="loginLoading"><img src="../../assets/img/loading.svg"></div>
                    <router-link to="/web/deposit" class="button button-green">{{ $t('DEPOSIT')}}</router-link>
                    <div class="user-notification">
                        <img src="../../assets/img/notification.svg" alt="notification icon">
                        <div class="notification-num">3</div>
                    </div>
                    <div class="line-sep"></div>
                    <div class="user-box">
                        <img src="../../assets/img/user.svg" alt="notification icon" class="user-icon">
                        <div class="user-data">
                            <p class="user-name">{{ playerdata.username }}</p>
                            <p class="user-balance">{{ playerdata.money.balance | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}</p>
                        </div>
                        <div class="user-menu">
                            <div class="loading-container" v-if="loginLoading"><img src="../../assets/img/loading.svg"></div>
                            <div class="user-menu-header">
                                <p class="user-name">{{ playerdata.username }}</p>
                                <p class="user-balance-menu">{{ $t('BALANCE')}} {{ playerdata.money.balance | formatNum}} {{ $getCurrencyAbbrv(playerdata.money.currency) }}</p>
                                <!-- p class="user-bonus">{{ $t('BONUSBALANCE')}} {{ playerdata.bonusBalance | formatNum}} {{ playerdata.wallet.currency }}</p -->
                                <p class="user-auth-text">{{$t('LOGGEDINFOR')}} {{ loggedInMinutes }} {{$t('MINUTES')}}</p>
                            </div>
                            <router-link to="/web/deposit" class="user-menu-item">{{ $t('DEPOSIT')}}</router-link>
                            <div class="user-menu-item">{{ $t('WITHDRAWAL')}}</div>
                            <div class="user-menu-item">{{ $t('MYBETS')}}</div>
                            <div class="user-menu-item">{{ $t('TRANSACTIONS')}} </div>
                            <div class="user-menu-item">{{ $t('PLAYERPROFILE')}}</div>
                            <div class="user-menu-item" v-on:click.prevent="logout">{{ $t('LOGOUT')}}</div>
                        </div>
                    </div>
                    <div class="user-logout">
                        <a href="" v-on:click.prevent="logout"><img src="../../assets/img/logout.svg" alt="notification icon" class="logout-icon"></a>
                    </div>
                </div>
            </div>
        </div>
        <!-- MOBILE HEADER-->
        <div class="header-mobile">
            <div class="headermob-content">
                <div class="headermob-left-box">
                    <i class="iconset icon-menu" @click="toggleMobileMenus('mobileMenu')"></i>
                    <div v-if="$route.meta && $route.meta.tournamentIdtle" class="headermob-button cta" href="">{{ $route.meta.tournamentIdtle }}</div>
                    <div v-else class="headermob-button cta" href="">{{ $t('DEFAULTPAGETITLE') }}</div>
                </div>
                <div class="headermob-logo-date">
                    <img v-if="getClientName === 'arenabet'"
                    src="../../assets/img/logo-arenabet-mob.svg" alt=""
                    class="headermob-logo-img">
                    <img v-else
                    src="../../assets/img/logo-em.svg" alt=""
                    class="headermob-logo-img">
                    <p class="headermob-date">{{ $predefinedLocalDateFormat(currenttime) }}</p>
                </div>
                <div class="headermob-right-box" v-if="!playerloggedin">
                    <div class="headermob-button cta">{{$t('POWEREDBYLEAPBIT')}}</div>
                </div>
                <!--div class="headermob-right-box" v-if="!playerloggedin">
                    <router-link to="/web/registration" class="headermob-button">{{$t('REGISTER')}}</router-link>
                    <a class="headermob-button yellow" @click="toggleMobileMenus('mobileLogin')">Login</a>
                </div-->
                <!--div class="headermob-right-box" v-if="playerloggedin">
                    <router-link to="/web/deposit" class="headermob-button green">{{ $t('DEPOSIT')}}</router-link>
                    <img src="../../assets/img/user.svg" alt="notification icon" class="user-icon" @click="toggleMobileMenus('userMobileMenu')">
                </div-->
            </div>
            <!-- mobile menu -->

                <div class="mobile-nav fadeInLeftMobileMenu" v-if="showMobileMenu">
                    <div class="mobnav-container">
                        <div class="mobnav-header">
                            <i class="iconset icon-close" @click="toggleMobileMenus('mobileMenu')"></i>
                            <img class="mobnav-logo-img" src="../../assets/img/logo-em.svg" alt="">
                        </div>
                        <div class="mobnav-menu">
                            <template v-for="(val, page) in verticalsAvailable">
                                <router-link @click.native="toggleMobileMenus()" :key="page" v-if="val" class="mobnav-menu-item" :to="getPageUrl(page)">
                                    <span class="ggame-heading-icon sport-icon" :class="'icon-'+page"></span>{{ $t(page.toUpperCase() + '_BETTINGVERTICAL') }}
                                </router-link>
                            </template>
                            <router-link @click.native="toggleMobileMenus()" :to="'/web/verifyticket/'" class="mobnav-menu-item">
                                <span class="ggame-heading-icon sport-icon icon-betslip"></span>{{ $t('VERIFYTICKET') }}
                            </router-link>
                            <router-link @click.native="toggleMobileMenus()" to="/web/results/sport/prematch" v-if="verticalsAvailable.prematch" class="mobnav-menu-item">
                            <span class="ggame-heading-icon sport-icon icon-results"></span>{{ $t('RESULTS') }}</router-link>
                            <router-link @click.native="toggleMobileMenus()" :to="'/web/results/' + getFirstAvailableResultsPage() + '/'" v-else class="mobnav-menu-item">
                            {{ $t('RESULTS') }}</router-link>
                        </div>
                        <!--div class="mobnav-info">
                            <router-link to="/web/wiki/how-to-bet" class="mobnav-info-item">{{ $t('HOWTOBET') }}</router-link>
                            <router-link to="/web/wiki/payment-methods" class="mobnav-info-item">{{ $t('PAYMENTMETHODS') }}</router-link>
                            <router-link to="/web/wiki/need-help" class="mobnav-info-item">{{ $t('NEEDHELP') }}</router-link>
                        </div-->
                    </div>
                    <div class="mobnav-container-fill" @click.stop="toggleMobileMenus('mobileMenu')"></div>
                </div>

            <!-- ********************* -->
            <!-- user mobile menu -->
            <transition name="slideInRight">
                <div class="mobile-nav right" v-if="playerloggedin && showUserMobileMenu">
                    <div class="mobnav-container right">
                        <div class="loading-container" v-if="loginLoading"><img src="../../assets/img/loading.svg"></div>
                        <div class="mobnav-header">
                            <img class="mobnav-close-icon rightMobileNavIconJs" src="../../assets/img/close.svg" alt="" @click="toggleMobileMenus('userMobileMenu')">
                            <img class="mobnav-logo-img" src="../../assets/img/logo-em.svg" alt="">
                        </div>
                        <div class="mobnav-user-info">
                            <p class="mobnav-user-item white">{{ playerdata.username }}</p>
                            <p class="mobnav-user-item">{{ $t('BALANCE')}} {{ playerdata.money.balance | formatNum}} {{ $getCurrencyAbbrv(globals.money.currency) }}</p>
                            <!-- p class="mobnav-user-item">{{ $t('BONUSBALANCE')}} {{ globals.bonusBalance | formatNum}} {{ globals.currency }}</p -->
                            <p class="mobnav-user-item small">{{$t('LOGGEDINFOR')}} {{ loggedInMinutes }} {{$t('MINUTES')}}</p>
                        </div>
                        <div class="mobnav-menu right">
                            <router-link to="/web/deposit" class="mobnav-menu-item active" href="">{{ $t('DEPOSIT')}}</router-link>
                            <a class="mobnav-menu-item" href="">{{ $t('WITHDRAWAL')}}</a>
                            <a class="mobnav-menu-item" href="">{{ $t('MYBETS')}}</a>
                            <a class="mobnav-menu-item" href="">{{ $t('TRANSACTIONS')}}</a>
                            <a class="mobnav-menu-item" href="">{{ $t('PLAYERPROFILE')}}</a>
                            <a class="mobnav-menu-item" href="" v-on:click.prevent="logout">{{ $t('LOGOUT')}}</a>
                        </div>
                    </div>
                </div>
            </transition>
            <!-- ********************* -->
            <!-- login mobile menu -->
            <transition name="slideInRight">
                <div class="mobile-nav right" v-show="!playerloggedin && showMobileLogin">
                    <div class="mobnav-container right">
                        <div class="mobnav-header">
                            <img class="mobnav-close-icon" src="../../assets/img/close.svg" alt="" @click="toggleMobileMenus('mobileLogin')">
                            <img class="mobnav-logo-img" src="../../assets/img/logo-em.svg" alt="">
                        </div>
                        <div class="mobnav-login">
                            <div class="loading-container" v-if="loginLoading"><img src="../../assets/img/loading.svg"></div>
                            <div class="input-box">
                                <input class="input-text" v-on:keyup.enter="login" v-model="username" type="text" ref_testcafe="loginUsername" placeholder="Username" :class="{'error': loginResponse.error}">
                                <p class="input-error" v-if="loginResponse.error">{{loginResponse.notice}}</p>
                            </div>
                            <div class="input-box">
                                <input class="input-text" v-on:keyup.enter="login" type="password"  v-model="password" ref_testcafe="loginPassword" placeholder="Password">
                                <p class="input-error">{{ $t('WRONG_PASSWORD')}}</p>
                            </div>
                            <button v-on:click.prevent="login" ref_testcafe="loginButton" class="button button-grey-second">{{ $t('LOGIN')}}</button>
                            <p>{{ $t('FORGOTPASSWORD')}}</p>
                            <div class="break-line"></div>
                            <!-- router-link to="/web/registration" class="button button-yellow">{{ $t('REGISTER')}}</router-link -->
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </header>
</template>

<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';

import moment from 'moment';

export default
{
    name: 'Header',
    data()
    {
        return {
            showMobileLogin: false,
            showUserMobileMenu: false,
            showMobileMenu: false,
            currenttime: moment.utc().format('YYYY-MM-DD HH:mm'),
            username: '',
            password: '',
            loginLoading: false,
            headerTitle: 'Demobet',
            loginResponse: {},
            loggedInMinutes: 0,
        };
    },
    async created()
    {
        const me = this;

        setInterval(() =>
        {
            me.currenttime = moment.utc().format('YYYY-MM-DD HH:mm');
            me.loggedInMinutes = Math.round((moment.utc() - moment.utc(me.playerdata.createTime)) / 1000 / 60);
        }, 1000);
    },
    methods:
    {
        ...mapActions([
            'loginplayer',
            'logoutplayer',
            'getTranslationByLangCode',
        ]),
        getPageUrl(page)
        {
            let url = '/web/';

            switch (page)
            {
            case 'prematch':
                url += 'sport';
                break;
            default:
                url += page;
            }

            return `${url}/`;
        },
        getFirstAvailableResultsPage()
        {
            const me = this;
            for (const vertical in me.verticalsAvailable)
            {
                if (me.verticalsAvailable[vertical])
                {
                    return vertical;
                }
            }
            return null;
        },
        async login()
        {
            const me = this;

            try
            {
                me.loginLoading = true;

                const data = await me.loginplayer({
                    username: this.username,
                    password: this.password,
                });

                me.loginResponse = data;
            }
            finally
            {
                me.loginLoading = false;
            }
        },
        logout()
        {
            const me = this;

            try
            {
                me.loginLoading = true;

                me.logoutplayer();
            }
            finally
            {
                me.loginLoading = false;
            }
        },
        toggleMobileMenus(menu)
        {
            if (menu === undefined)
            {
                this.showMobileMenu = false;
                this.showMobileLogin = false;
                this.showUserMobileMenu = false;

                return;
            }

            if (menu === 'mobileMenu')
            {
                this.showMobileMenu = !this.showMobileMenu;
            }
            if (menu === 'mobileLogin')
            {
                this.showMobileLogin = !this.showMobileLogin;
            }
            if (menu === 'userMobileMenu')
            {
                this.showUserMobileMenu = !this.showUserMobileMenu;
            }
        },
        changeRouteLang(langCode)
        {
            const me = this;

            if (langCode !== me.globals.langCode)
            {
                me.getTranslationByLangCode(langCode);
            }
        },
    },
    computed:
    {
        ...mapGetters({
            isMobile: 'isMobile',
            globals: 'globals',
            verticalsAvailable: 'verticalsAvailable',
            playerdata: 'playerdata',
        }),
        playerloggedin()
        {
            return this.globals.groupId === 3;
        },
        getClientName()
        {
            // eslint-disable-next-line no-undef
            return CLIENT_NAME;
        },
        getGitHash()
        {
            // eslint-disable-next-line no-undef
            return `Commit: ${GIT_HASH}`;
        },
        showGitHash()
        {
            try
            {
                return Boolean(process.env.VUE_APP_SHOW_GIT_TAG);
            }
            catch
            {
                return false;
            }
        },
    },
};
</script>
